import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeAccountSubListItem extends SearchModelBase {
    code: string = '';
    desc1: string = '';
    id: number = 0;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Sub Code', width: 200, dataIndex: 'code'}),
        XCol.Create({ col: 1, text: 'Desc', width: 1000, dataIndex: 'desc1'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeAccountSubListItem.prototype.id, orderByAscending: false };

    public static formatData(data: CodeAccountSubListItem[]) {
        return data.map((d: CodeAccountSubListItem) => ({
          ...d,
        }));
    }

}
